module.exports = __webpack_public_path__ + "img/bucket-3.77d1effc.svg";